import fetchAdUser from './fetchAdUser'
import { USER_LOGIN_REDIRECT, USER_AUTH_KEY } from '../../utils/constants'
export const SET_CREATE_SESSION_FLAG = 'SET_CREATE_SESSION_FLAG'
export const SET_ERROR = 'SET_ERROR'
export const SET_REDIRECT_ROUTE = 'SET_REDIRECT_ROUTE'
export const SET_USER = 'SET_USER'
export const SET_AUTH_MODE = 'SET_AUTH_MODE'

export const createSession = (id_token, client_info, session_state, state, code_verifier) => {
  return async (dispatch, getState) => {
    const { isCreatingSession } = getState()
    const ttlMinutes = 30 // two hours
    if (isCreatingSession) return

    dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: true })
    try {
      if (id_token) {
        dispatch({ type: SET_AUTH_MODE, authMode: 'msid' })
        // If id_token is present it is a AD authentication. Validate the token at the backend and
        // get back the user information along with the session cookies.

        const user = await fetchAdUser(
          id_token,
          client_info,
          session_state,
          state,
          code_verifier
        )
        if(user.statusCode===200 && user.value==="User Authenticated.")
        {
          const authenticate = async () => {
           await fetch(
              `${process.env.REACT_APP_BACKEND_BASE_URL}/getuserprofiledetails`,
              {
                method: 'get',
                headers: {
                  'Content-Type': 'application/json',
                  //requester: JSON.stringify(window.localStorage.getItem('requester')),
                },
                withCredentials: true,
                credentials: 'include',
              }
            )
              .then((response) => response.json())

              .then((data) => {
                if (data.response_code === 200) {
                  let userData = data.response_data
                  const user = {
                    firstName: userData.firstname,
                    lastName: userData.lastname,
                    email: userData.email,
                    username: userData.username,
                    sortName: userData.sortname,
                    phone: userData.phone,
                    role: userData.role,
				               	policyversion: userData.policyversion,
                    preferences: {
                      timeZone: 'America/Chicago',
                      timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
                    },
                    expiry: userData.expiry,
                    uuid: userData.uuid,
                    userid: userData.userid,
                    usercomponents: userData.usercomponents.split(','),
                  }
                  window.localStorage.setItem('exp', user.expiry)
                  window.localStorage.setItem('requester', JSON.stringify(user))
                  
                  dispatch({ type: SET_USER, user })
                } else if (data.response_code === 400) {
                } else if (data.response_code === 401) {
                } else {
                }
              })
              .catch((err) => {
                
              })

           
          }

          await authenticate()
        }
        else{
          dispatch({ type: SET_ERROR, error: 'User authentication failed. Please try again.' })
           dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false })
        }
      } else {
        dispatch({ type: SET_AUTH_MODE, authMode: 'ohid' })
        if (
          process.env.REACT_APP_DEVELOPMENT_MODE === undefined ||
          process.env.REACT_APP_DEVELOPMENT_MODE === 'true'
        ) {
          const user = {
            firstName: 'Mohd',
            lastName: 'Rizwaan',
            email: 'mohammad.rizwaan@optum.com',
            username: 'mrizwaan',
            sortName: 'MR',
            phone: '+18888888888',
            role: 'Admin',
			         policyversion: 'v3.0',
            preferences: {
              timeZone: 'America/Chicago',
              timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
            },
            expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
            uuid: 'fc8c9855-711b-40b1-9548-225562149f45',
            userid: 10,
           usercomponents: ['flumeter','meningitisdashboard','utidashboard','askai','invitationmaster','invitation','heatmap','home','about','dashboard','fludashboard','rsvdashboard','coviddashboard','vulnerabilitydashboard','imagegenerate','birthtrenddashboard','modeldashboard','flunewmap','allergiesdashboard','vaccinationdashboard','rarediseasedashboard','surveillancedashboard']
            
          }

          // fetch(
          //   `${process.env.REACT_APP_BACKEND_BASE_URL}/getuserprofiledetails`,
          //   {
          //     method: 'get',
          //     headers: {
          //       'Content-Type': 'application/json',
          //       //requester: JSON.stringify(window.localStorage.getItem('requester')),
          //     },
          //     withCredentials: true,
          //     credentials: 'include',
          //   }
          // )
          //   .then((response) => response.json())
      
          //   .then((data) => {
          //     if (data.response_code === 200) {
          //       let userData=data.response_data
          //       const user = {
          //         firstName: userData.firstname,
          //         lastName: userData.lastname,
          //         email: userData.email,
          //         username: userData.username,
          //         sortName: userData.sortname,
          //         phone: userData.phone,
          //         role: userData.role,
		  //         policyversion: 'v3.0',
          //         preferences: {
          //           timeZone: 'America/Chicago',
          //           timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
          //         },
          //         expiry:  new Date().getTime() + ttlMinutes * 60 * 1000,
          //         uuid: userData.uuid,
          //         userid: userData.userid,
          //       }
          //       window.localStorage.setItem('requester', JSON.stringify(user))
          
          //       dispatch({ type: SET_USER, user })
                
          //     } 
          //   })
          //   .catch((err) => {
          //   })

          // TODO: add this in when backend is ready! This is OAuth 2.0 flow to
          // check the existence of user in the authenticating system.
          // const user = await fetchUser(TEST_USER_EMAIL)
          // const user = {
          //   firstName: 'Vijay',
          //   lastName: 'Yadav',
          //   email: 'vijay_yadav29@optum.com',
          //   username: 'vyadav29',
          //   sortName: 'VY',
          //   phone: '+18888888888',
          //   role: 'Basic',
		  //   policyversion: 'v3.0',
          //   preferences: {
          //     timeZone: 'America/Chicago',
          //     timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
          //   },
          //   expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
          //   uuid: 'fc8c9855-711b-40b1-9548-225562149f45',
          //   userid: 3,
          // }
          window.localStorage.setItem('requester', JSON.stringify(user))
          
          dispatch({ type: SET_USER, user })
        } else {
          const authenticate = async () => {
           await fetch(
              `${process.env.REACT_APP_BACKEND_BASE_URL}/getuserprofiledetails`,
              {
                method: 'get',
                headers: {
                  'Content-Type': 'application/json',
                  //requester: JSON.stringify(window.localStorage.getItem('requester')),
                },
                withCredentials: true,
                credentials: 'include',
              }
            )
              .then((response) => response.json())

              .then((data) => {
                if (data.response_code === 200) {
                  let userData = data.response_data
                  const user = {
                    firstName: userData.firstname,
                    lastName: userData.lastname,
                    email: userData.email,
                    username: userData.username,
                    sortName: userData.sortname,
                    phone: userData.phone,
                    role: userData.role,
				               	policyversion: userData.policyversion,
                    preferences: {
                      timeZone: 'America/Chicago',
                      timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
                    },
                    expiry: userData.expiry,
                    uuid: userData.uuid,
                    userid: userData.userid,
                    usercomponents: userData.usercomponents.split(','),
                  }
                  window.localStorage.setItem('exp', user.expiry)
                  window.localStorage.setItem('requester', JSON.stringify(user))
                  
                  dispatch({ type: SET_USER, user })
                } else if (data.response_code === 400) {
                } else if (data.response_code === 401) {
                } else {
                }
              })
              .catch((err) => {
                // <ErrorMessage
                //   errorCode={'201'}
                //   errorMessage={
                //     'You can try reloading the page now or in a few minutes.'
                //   }
                //   errorSubject={'Unable to load the page'}
                //   errorDetails={err}
                // />
              })

            //  check for cookie 'idpprofile' that should be present
            // this cookie is only valid for 30seconds
            // const cookies = document.cookie
            // const cookie = require('cookie')
            // const cookieObjects = cookie.parse(cookies)
            // const idpCookie = cookieObjects['idprsvprofile']
            // if (!idpCookie) {
            //   return
            // }
            // const {
            //   username,
            //   givenName,
            //   familyName,
            //   profileName,
            //   role,
            //   email,
            //   phone,
            //   exp,
            //   uuid,
            //   id,
            // } = jwtDecode(idpCookie)
            // TODO: enable this when we are going to have backend store user information
            // const user = await fetchUser(username)
            // window.localStorage.setItem('exp', exp)
            // const user = {
            //   username: username,
            //   firstName: givenName,
            //   lastName: familyName,
            //   sortName: profileName,
            //   role: role,
            //   email: email,
            //   phone: phone,
            //   preferences: {
            //     timeZone: 'America/Chicago',
            //     timeZoneDisplay: 'DD/MM/YYYY, h:mm:ss A z',
            //   },
            //   expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
            //   uuid: uuid,
            //   userid: id,
            // }
            // window.localStorage.setItem('requester', JSON.stringify(user))
           
            // dispatch({ type: SET_USER, user })
          }

          await authenticate()
        }
      }
      dispatch({ type: SET_REDIRECT_ROUTE, route: '/' })
      dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false })
    } catch (error) {
      dispatch({ type: SET_ERROR, error })
      dispatch({ type: SET_CREATE_SESSION_FLAG, isCreatingSession: false })
    }
  }
}

export const clearSession = () => {
  return async (dispatch) => {
    window.localStorage.removeItem(USER_AUTH_KEY)
    window.localStorage.removeItem(USER_LOGIN_REDIRECT)
    dispatch({ type: SET_USER, user: null })
  }
}

export const preventNextRedirect = () => ({
  type: SET_REDIRECT_ROUTE,
  route: null,
})
